import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchServiceRate = (params) => apiActionCreator({
  'endpoint': `/service-rate${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SERVICE_RATE,
    ActionTypes.FETCHED_SERVICE_RATE,
    [
      ActionTypes.FETCHED_SERVICE_RATE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadServiceRateFile = (params) =>
  apiActionCreator({
    'endpoint': `/service-rate/download/excel${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_SERVICE_RATE_FILE,
      ActionTypes.DOWNLOADED_SERVICE_RATE_FILE,
      [
        ActionTypes.DOWNLOADED_SERVICE_RATE_FILE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchIcc = () =>
  apiActionCreator({
    'endpoint': '/parts/icc',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ICC,
      ActionTypes.FETCHED_ICC,
      [
        ActionTypes.FETCHED_ICC_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const deleteUrlServiceRate = (data) => ({
  'type': ActionTypes.DELETE_URL_SERVICE_RATE,
});

export const deleteServiceReport = () => ({
  'type': ActionTypes.DELETE_SERVICE_RATE,
});
